module.exports = __webpack_public_path__ + "media/packs/images/flags/LU-3c8c2e28826d596a7130b492c5eea217.svg";